import React from 'react'
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import Categories from "../components/Categories/Categories";
import Divider from "../components/Divider/Divider";
import SEO from "../components/SEO/SEO";
import CarFleet from "../components/CarFleet/CarFleet";
import Benefits from "../components/Benefits/Benefits";
import LuxuryFleet from '../components/LuxuryFleet/LuxuryFleet';
import PrivateTransfer from '../components/PrivateTransfer/PrivateTransfer';
import MotoFleet from '../components/MotoFleet/MotoFleet';
import Tesla from "../assets/images/tesla divider.png";
import Ferrari from "../assets/images/ferrari divider.png";
import { GrShare } from "react-icons/gr";
import GetInTouch from '../components/GetInTouch/GetInTouch';
import Footer from "../components/Footer/Footer";

const Home = () => {
  // Get the current window origin
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://mykonosrentacars.com';
  
  return (
    <>
<SEO
  title="Luxury Car Mykonos • Rent a Car in Mykonos"
  description="Discover our fleet of luxury cars, motos and private transfers on Luxury Car Mykonos. Great rates, no hidden fees."
  canonicalUrl={origin}
  imageUrl={`${origin}/og-homepage.jpg`}
  imageAlt="Luxury Car Mykonos - Fleet overview"
  structuredData={{
    "@context": "https://schema.org/",
    "@type": "WebSite",
    "url": origin,
    "name": "Luxury Car Mykonos",
    "description": "Discover our fleet of luxury cars, motos and private transfers on Luxury Car Mykonos. Great rates, no hidden fees.",
    "publisher": {
      "@type": "Organization",
      "name": "Luxury Car Mykonos",
      "logo": {
        "@type": "ImageObject",
        "url": `${origin}/logo-1.png`
      }
    }
  }}
/>
      <div className="App OpenSans bg-gray-50">
        <Header />
        <Hero />
        <Categories />
        <Divider 
          text="Check out all Rental Cars!"
          buttonText="Click here"
          showImages={true}
          icon={GrShare}
          images={[
            { src: Tesla, alt: "Tesla", className: "lg:h-16 h-24" },
            { src: Ferrari, alt: "Ferrari", className: "lg:w-48 -mb-12" }
          ]}
        />
        <CarFleet />
        <Benefits />  
        <LuxuryFleet />
        <PrivateTransfer />
        <MotoFleet />
        <Divider 
          text="Rent a Car near you by giving us a Call!!"
          buttonText="CALL US NOW"
        />
        <GetInTouch />
        <Footer />
      </div>
    </>
  );
};

export default Home